import {
  Button,
  Card,
  Col,
  Image,
  Row,
  Select,
  Table,
  Tabs,
  Tooltip,
  Input,
  Switch,
  Space,
} from "antd";
import moment from "moment";
import { UndoOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Plus from "../../assets/images/plus.svg";
import ConfirmationBox from "../../components/ConfirmationBox";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";

import { AppStateContext, useAppContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import DeleteModal from "../../components/DeleteModal";
// import AddForm from "./AddForm";
import EditIcon from "../../assets/images/edit.svg";
const { TabPane } = Tabs;

function Faq() {
  const routeName = "faq";
  const params = useParams();

  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");

  const api = {
    list: `${apiPath.helpCenter}/list-faq`,
    status: `${apiPath.helpCenter}/faq`,
    addEdit: `${apiPath.helpCenter}/faq`,
    filterServices: apiPath.allServices,
  };

  const [searchText, setSearchText] = useState("");

  const { request } = useRequest();
  const navigate = useNavigate();
  const { showConfirm } = ConfirmationBox();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [logs, showLogs] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [page, setPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState("all");
  const debouncedSearchText = useDebounce(searchText, 300);
  const [searchCity, setSearchCity] = useState("");
  const debouncedSearchCity = useDebounce(searchCity, 300);
  const [showMessage, setShowMessage] = useState(false);
  const [countries, setCountries] = useState([]);
  const [showStatusMessage, setShowStatusMessage] = useState(false);
  const [paramsIds, setParamsIds] = useState({});
  const [exportLoading, setExportLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [categories, setCategory] = useState([]);
  const [services, setServices] = useState([]);
  const { language } = useAppContext();
  const [checkStrictly, setCheckStrictly] = useState(false);
  const [allStatusChangeModal, setAllStatusChangeModal] = useState(false);
  const [statusKey, setStatusKey] = useState("");

  const [filter, setFilter] = useState({
    country_id: undefined,
    year: undefined,
    category: undefined,
    service_id: undefined,
  });

  const onDelete = (id) => {
    request({
      url: api.addEdit + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, message) => {
    request({
      url: api.status + "/" + id,
      method: "PUT",
      data: { message },
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: lang("question"),
      dataIndex: "question",
      key: "question",
      width: 200,
      sorter: (a, b) => a?.question?.localeCompare(b?.question),
      sortDirections: ["ascend", "descend"],
      render: (_, { question }) =>
        question ? (
          <span
            className="cap"
            dangerouslySetInnerHTML={{ __html: question }}
          />
        ) : (
          "-"
        ),
    },

    {
      title: lang("answer"),
      dataIndex: "answer",
      key: "answer",
      width: 200,
      sorter: (a, b) => a?.answer?.localeCompare(b?.answer),
      sortDirections: ["ascend", "descend"],
      render: (_, { answer }) =>
        answer ? (
          <span className="cap" dangerouslySetInnerHTML={{ __html: answer }} />
        ) : (
          "-"
        ),
    },

    {
      title: lang("Category"),
      dataIndex: "category",
      key: "category",
      width: 200,

      render: (_, { category }) =>
        category ? <span className="cap">{category}</span> : "-",
    },
    // Table.EXPAND_COLUMN,

    {
      title: lang("Register Date"),
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: lang("Action"),
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div
            className="action-buttons-containermain"
            style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}
          >
            <Tooltip
              title={lang("Edit")}
              color={"purple"}
              key={"Edit" + routeName}
              className="main-second-classforedit-5"
            >
              <Button
                title={lang("Edit")}
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  navigate(`/help-center/edit-faq/${record._id}`);
                }}
              >
                <img src={EditIcon} />
                <span>{lang("Edit")}</span>
              </Button>
            </Tooltip>
            <Tooltip
              title={lang("Delete")}
              color={"purple"}
              key={"delete" + routeName}
            >
              <Button
                size="small"
                className="delete-cls"
                title={lang("Delete")}
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i className="fa fa-light fa-trash"></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const getFilter = () => {
    request({
      url: `${apiPath.helpCenter}/list-faq/filters`,
      method: "GET",
      onSuccess: (res) => {
        const { data, months, years } = res;
        setCategory(data);
      },
    });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);

    getFilter();
  }, [refresh, debouncedSearchText, filter]);

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : null;

    const queryString = Object.entries(filter)
      .filter(([_, v]) => v)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    request({
      url:
        apiPath.helpCenter +
        `/list-faq/?status=${filterActive ? filterActive.join(",") : ""}&page=${pagination ? pagination.current : 1
        }&pageSize=${pagination.pageSize ?? 10}&search=${debouncedSearchText}${queryString ? `&${queryString}` : ""
        }${path ? `&status=${path}` : ""}`,
      method: "GET",
      onSuccess: ({ data, status, total }) => {
        setLoading(false);
        console.log(data, "data11");
        if (status) {
          // setList(data.docs);
          setSelectedIds([]);
          setList(() => {
            return data.docs.map((item) => {
              return {
                ...item,
                key: item._id,
              };
            });
          });
          setPagination((prev) => ({
            pageSize: pagination.pageSize,
            current: pagination.current,
            total: data.totalDocs,
          }));
        }
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  return (
    <>
      <div className="tabled quoteManagement">
        <SectionWrapper
          cardHeading={lang("All Faq")}
          cardSubheading={""}
          extra={
            <>
              {/* <div className="button_group justify-content-end w-100"> */}
              <div className="w-100 text-head_right_cont">
                <div className="pageHeadingSearch pageHeadingSearchnew-add-faqq">
                  <Input.Search
                    className="searchInput"
                    placeholder={lang("Search by keyword")}
                    onChange={onSearch}
                    value={searchText}
                  />
                  <div className="button-sec main-new-add-faq-butons_main">
                    <Button
                      className=" primary_btn btnStyle main-new-add-faq-butons"
                      onClick={(e) => {
                        navigate("/help-center/edit-faq");
                      }}
                    >
                      <span className="add-Ic">
                        <img src={Plus} />
                      </span>
                      {lang("Add")} {lang("Faq")}
                    </Button>
                  </div>
                </div>

                {/* <div className="role-wrap">
                        <Select
                          last20Years
                          width="110px"
                          placeholder={lang("Type")}
                          showSearch
                          value={filter?.type}
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          options={attributeOption?.map((item) => ({
                            value: item.value,
                            label: item.label,
                          }))}
                          onChange={(value) => onChange("type", value)}
                        />
                      </div> */}
              </div>
            </>
          }
        >
          <div className="table-responsive customPagination">
            <Table
              loading={loading}
              columns={columns}
              dataSource={list}
              pagination={{
                current: pagination?.current,
                defaultPageSize: 10,
                responsive: true,
                total: pagination.total,
                showSizeChanger: true,
                showQuickJumper: true,
              }}
              // expandable={{
              //   expandedRowRender: (record) => (
              //     <div className="sec-add-table">
              //     <p  style={{  margin: 0,  }}   >
              //     <span>{lang("Services")} :</span>   {record.service_id?.length ? <span className="cap">[{record?.service_id?.map((item) => language !== "en" && language !== null
              //    ? item?.[`${language}_name`] ?? item?.name
              //     : item?.name)?.join(", ")}]  </span> : "No Services"}
              //     </p>
              //     <p  style={{  margin: 0,  }}   >
              //     <span>{lang("Options")} :</span>  {record.options?.length  ? <span className="cap">[{record?.options?.map((item) => language !== "en" && language !== null
              //     ? item?.[`${language}_name`] ?? item?.name
              //     : item?.name)?.join(", ")}]  </span> : "-"}
              //     </p>
              //     </div>
              //   ),
              // }}
              onChange={handleChange}
              className="ant-border-space"
            />
          </div>
        </SectionWrapper>
      </div>

      {/* {visible && (
        <AddForm
          section={sectionName}
          api={api}
          show={visible}
          paramsIds={paramsIds}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )} */}

      {showDelete && (
        <DeleteModal
          title={lang("Delete Faq")}
          subtitle={lang(`Are you sure you want to Delete this Faq?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
}

export default Faq;
